<template>
  <!-- Projects component -->
  <Projects/>
</template>

<script>
// @ is an alias to /src
import Projects from "../components/Projects";
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'Home',
  components: {
    Projects
  },
  computed: {
    ...mapGetters(['isAuthenticated']),
  },
  methods: {
    ...mapMutations(['clearErrors'])
  },
  mounted() {
    if (!this.isAuthenticated) {
      // login failed, show login page
      this.clearErrors()
      this.$router.push('/login')
    }
  }
}
</script>
